import type { WorkflowId } from "./workflowTypes";

export interface WorkflowActivationPolicy {
  isActive(workflowId: WorkflowId): boolean;
}

export class AllWorkflowsActiveWorkflowActivationPolicy implements WorkflowActivationPolicy {
  isActive(_workflowId: WorkflowId): boolean {
    return true;
  }
}
